import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Types} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [{
	name: 'Copyables',
	url: '/copyables',
	icon: 'dashboard'
}];

export default class Copyables extends Framework.Components.View {

	constructor(props) {
	super(props);
	this.getUserRoles();
}

	getUserRoles = async () => {
		let model = new API.BuildClass(Types.Roles._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		this.data = await model.submit(null, this.read);
		this.setState({
			userRoles: this.data.items,
		});
	}

	render() {
		return(

			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					{this.props.roles.includes(UserRoles.Admin) &&
						<Button onClick={this.toggle('modalCopyableAdd')} size={"sm"} color="primary">
							<i className="fa fa-users"/>&nbsp;&nbsp;Add Copyable
						</Button>
					}
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Copyable"}
					object={Objects.Copyable}
					history={history}
					objectProps={{isNew: true, userRoles: this.state.userRoles}}
					toggle={this.state.modalCopyableAdd}
					reportClose={this.reportClose('modalCopyableAdd')}
					afterSave={this.refreshPage}
				/>
				<Collections.Copyables key={this.state.key} roles={this.props.roles} userRoles={this.state.userRoles}/>
			</div>


		)
	}
}